import React, { useState } from "react";
import {
  Table,
  TableColumn,
  TableParams,
  TableRowKey,
} from "@datapay-by-datacom/design-system";
import type { UseQueryResult } from "@tanstack/react-query";
import { OrgCategory, OrgInvitation } from "../../../generated/core-api";
import { useListOrgInvitations } from "../../hooks";
import { OrgInviteTableActions } from "./OrgInviteTableActions";

type OrgInviteTableData = OrgInvitation & {
  actions: string;
};

const columns: TableColumn<OrgInviteTableData>[] = [
  {
    key: "recipient_name",
    cell(row) {
      if (row.recipient_name) {
        return row.recipient_name;
      } else if (row.recipient_email) {
        return row.recipient_email;
      } else if (row.recipient_mobile) {
        return row.recipient_mobile;
      }
      return "-";
    },
    header() {
      return "Recipient Name";
    },
  },
  {
    key: "role",
    cell(row) {
      return row.role;
    },
    header() {
      return "Role";
    },
  },
  {
    key: "delivery_method",
    cell(row) {
      return row.delivery_method;
    },
    header() {
      return "Delivery Method";
    },
  },
  {
    key: "created_at",
    cell(row) {
      return new Date(row.created_at).toLocaleString();
    },
    header() {
      return "Created At";
    },
  },
  {
    key: "actions",
    cell(row) {
      return <OrgInviteTableActions invite={row} />;
    },
    header() {
      return "Actions";
    },
  },
];

const rowKey: TableRowKey<OrgInviteTableData> = (row) => row.invitation_id;

interface OrgInviteTableProps {
  category: OrgCategory;
  id: string;
}

export function OrgInviteTable({ category, id }: OrgInviteTableProps) {
  const [tableParams, setTableParams] = useState<
    TableParams<OrgInviteTableData>
  >({});
  const invitesQuery = useListOrgInvitations(category, id);

  return (
    <Table
      description="Organization Invites"
      config={{
        columns,
        rowKey,
      }}
      control={{ params: tableParams, onParamsChange: setTableParams }}
      query={invitesQuery as unknown as UseQueryResult<OrgInviteTableData[], Error>}
    />
  );
}
